module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"text":"Načítání ..."},"de":{"text":"Wird geladen..."},"es":{"text":"Cargando..."},"fr":{"text":"Chargement..."}}')
  delete Component.options._Ctor
}
